import i18n from '../locales/index'
/**
 *电子秤
 */
export const setZero = () => {
  // 归零
  if (window.TurbolinksJavaScriptObject) {
    window.TurbolinksJavaScriptObject.setZero()
  }
}
export const setTare = () => {
  // 去皮
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.setTare()
    } catch {
      console.log('setTare报错了')
    }
  }
}
export const getWight = () => {
  // 获取电子秤重量
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.getWight()
    } catch {
      console.log('getWight报错了')
    }
  }
  return false
}
export const openScale = (val, addr, type, port) => {
  // 开启或关闭安卓推送的重量
  if (window.TurbolinksJavaScriptObject) {
    try {
      if (val && (addr || type || port)) {
        window.TurbolinksJavaScriptObject.openScale(val, addr, type, port)
      }
    } catch {
      console.log('openScale报错了')
    }
  }
}

/**
 *钱箱
 */
export const openCashBox = () => {
  // 打开钱箱
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.openCashBox()
    } catch {
      console.log('openCashBox报错了')
    }
    return true
  }
  return false
}

/**
 *客显
 */
export const initGuestDisplay = (addr, port) => {
  // 初始化客显
  if (window.TurbolinksJavaScriptObject) {
    try {
      if (addr && port) {
        window.TurbolinksJavaScriptObject.initGuestDisplay(addr, port)
      }
    } catch {
      console.log('initGuestDisplay报错了')
    }
  }
}

export const clearGuestDisplay = () => {
  // 客显清屏
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.clearGuestDisplay()
    } catch {
      console.log('clearGuestDisplay报错了')
    }
  }
}

export const showGuestDisplayType = (type) => {
  // 客显类型 0 全暗 1.单价 2 总计 3. 收款 4 找零
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.showGuestDisplayType(type)
    } catch {
      console.log('showGuestDisplayType报错了')
    }
  }
}

export const showGuestDisplayData = (data) => {
  // 显示数据,与showGuestDisplayType配合使用
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.showGuestDisplayData(data)
    } catch {
      console.log('showGuestDisplayData报错了')
    }
  }
}

export const showGuestDisplayLight = (d1, d2, d3, d4) => {
  /**
   * 用来开关客显的四个灯
   * 当d1=0时，单价灯灭；d1=1时，单价灯亮
   * 当d2=0时，总计灯灭；d2=1时，总计灯亮
   * 当d3=0时，收款灯灭；d3=1时，收款灯亮
   * 当d4=0时，找零灯灭；d4=1时，找零灯亮
   * */
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.showGuestDisplayLight(d1, d2, d3, d4)
    } catch {
      console.log('showGuestDisplayLight报错了')
    }
  }
}

/**
 * 双屏显示
 * */

export const isShowSecondDisplay = () => {
  // 返回结果 “1”已开启 “0”未开启
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.isShowSecondDisplay()
    } catch {
      console.log('isShowSecondDisplay报错了')
    }
  }
  return false
}

export const showSecondDisplay = (show, type) => {
  /**
   * show "1" 显示副屏 "0" 隐藏副屏
   * type "1" 轮播图 "0" 视频
   * */
  if (window.TurbolinksJavaScriptObject) {
    try {
      const t = show ? '1' : '0'
      window.TurbolinksJavaScriptObject.showSecondDisplay(t, type)
    } catch {
      console.log('showSecondDisplay报错了')
    }
  }
}

export const secondDispalyShowType = () => {
  // 返回 "0"播放视频 "1"播放轮播图
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.secondDispalyShowType()
    } catch {
      console.log('secondDispalyShowType报错了')
    }
  }
  return false
}

export const setSecondaryScreenDisplay = (data) => {
  // 副屏商品列表
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.updateProduct(JSON.stringify(data))
    } catch {
      console.log('updateProduct报错了')
    }
  }
}

export const orderOver = () => {
  // 点单结束
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.orderOver()
    } catch {
      console.log('orderOver报错了')
    }
  }
}

export const getSecondDispalyVideoDirectory = () => {
  // 获取副屏要显示的视频文件存放路径
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.getSecondDispalyVideoDirectory()
    } catch {
      console.log('getSecondDispalyVideoDirectory报错了')
    }
  }
  return i18n.t('libs_android_jsbridge_49')
}

export const getSecondDispalyImageDirectory = () => {
  // 获取副屏要显示的轮播图存放路径
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.getSecondDispalyImageDirectory()
    } catch {
      console.log('getSecondDispalyImageDirectory报错了')
    }
  }
  return i18n.t('libs_android_jsbridge_49')
}

/**
 * 打印
 * @printerConfigNO 打印机编号
 * @suborderNumber 子订单标号
 */
export const print = (content) => {
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.print(content)
    } catch {
      console.log('print报错了')
    }
  }
}
export const showPrinterSetting = () => {
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.showPrinterSetting()
    } catch {
      console.log('showPrinterSetting报错了')
    }
  }
}

/**
 * 退到桌面
 */

export const backToHome = () => {
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.backToHome()
    } catch {
      console.log('backToHome报错了')
    }
  }
}

/**
 * 打开后台管理系统
 */

export const openUrlOnBrowser = () => {
  if (window.TurbolinksJavaScriptObject) {
    try {
      window.TurbolinksJavaScriptObject.openAdmin()
    } catch {
      console.log('openUrlOnBrowser')
    }
  }
}

/**
 * 打开外部浏览器
 */

export const openUrlOnExternalBrowser = (url) => {
  if (window.Admin) {
    try {
      window.Admin.openUrlOnBrowser(url)
    } catch {
      console.log('openUrlOnBrowser')
    }
  }
}

export const isAndroidApp = () => {
  if (window.Admin) {
    try {
      return window.Admin.isAndroidApp()
    } catch {
      console.log('isAndroidApp')
    }
  }
}

/**
 * 返回前台页面
 */

export const backToAndroidCash = () => {
  console.log('开始调用backToAndroidCash')
  if (window.Admin) {
    try {
      console.log('调用了backToAndroidCash')
      window.Admin.backToCash()
    } catch {
      console.log('backToAndroidCash')
    }
  }
}

/**
 * 获取App版本
 */

export const getAppVersion = () => {
  if (window.TurbolinksJavaScriptObject) {
    try {
      return window.TurbolinksJavaScriptObject.getAppVersion()
    } catch {
      console.log('openUrlOnBrowser')
    }
  }
}

/**
 * 设置IC读卡
 */
export const setReadIc = (fn) => {
  window.readIc = (code) => {
    fn(code);
  }
}
